import type { ClassificationGroupDepth, ResultGroupBy } from './types';

const DEPTH_LABELS: Record<'record' | 'function', [string, string, string]> = {
  record: ['Function', 'Activity', 'Record Type'],
  function: ['Domain', 'Subdomain', 'Function'],
};

function hasDepthLabels(groupBy: ResultGroupBy): groupBy is 'record' | 'function' {
  return groupBy in DEPTH_LABELS;
}

const GroupingControls = ({
  groupBy,
  classificationGroupDepth,
  setGroupBy,
  setClassificationGroupDepth,
}: {
  groupBy: ResultGroupBy;
  classificationGroupDepth: ClassificationGroupDepth;
  setGroupBy: (value: ResultGroupBy) => void;
  setClassificationGroupDepth: (value: ClassificationGroupDepth) => void;
}) => {
  return (
    <div className="space-y-2">
      <div>
        <select
          value={groupBy}
          onChange={(e) => setGroupBy(e.target.value as ResultGroupBy)}
          className={`w-full text-sm border rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-emerald-500 ${
            groupBy !== 'none'
              ? 'border-emerald-500 bg-emerald-50 text-emerald-700'
              : 'border-gray-200 text-gray-600'
          }`}
        >
          <option value="none">No grouping</option>
          <option value="record" title="The formal categorisation determining the type of record.">
            Record classification
          </option>
          <option value="function" title="The primary business activity this document relates to.">
            Business Function
          </option>
          <option value="address" title="The full validated address the document relates to.">
            Full address
          </option>
          <option value="street" title="The street and town the document relates to.">
            Street
          </option>
        </select>
      </div>

      {hasDepthLabels(groupBy) && (
        <select
          value={classificationGroupDepth}
          onChange={(e) => setClassificationGroupDepth(Number(e.target.value) as ClassificationGroupDepth)}
          className="w-full text-sm border rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-emerald-500 border-emerald-500 bg-emerald-50 text-emerald-700"
        >
          {DEPTH_LABELS[groupBy].map((label, i) => (
            <option key={label} value={i + 1}>
              {label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default GroupingControls;
